import { render, staticRenderFns } from "./PosterSetup.vue?vue&type=template&id=11b0d23c&"
import script from "./PosterSetup.vue?vue&type=script&lang=js&"
export * from "./PosterSetup.vue?vue&type=script&lang=js&"
import style0 from "./PosterSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports